import { ProgramListItemActionButton } from 'elements/eventView/atomic/ProgramListItem/ProgramListItemActionButton';
import { useAnalytics } from 'libs/utils/site/analytics';
import { useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    storyIds?: string[];
    programId: string;
    markerId: string | null;
    title: string;
}

export const ShowDetailButton = (props: Props): JSX.Element => {
    const ctxEventView = useContext(CtxEventView);
    const analytics = useAnalytics();
    const [searchParams, setSearchParams] = useSearchParams();

    const { eventPath, isWide } = ctxEventView;
    const isMobile = !isWide;

    const navigate = useNavigate();

    function handleInfoClick() {
        const isOneStory = props.storyIds?.length === 1;

        if (isMobile) {
            if (isOneStory) {
                const mobilePath = `/event/${eventPath}/program/${props.storyIds[0]}`;
                navigate(mobilePath);
            } else {
                const mobilePath = `/event/${eventPath}/program/list/${props.programId}`;
                navigate(mobilePath);
            }
        }

        if (!isMobile) {
            if (props.markerId) {
                searchParams.set('markerId', props.markerId);
            } else {
                searchParams.delete('markerId');
            }

            if (isOneStory) {
                searchParams.set('detailId', props.storyIds[0]);
                searchParams.delete('detailEntityType');
                searchParams.delete('detailEntityId');
            } else {
                searchParams.delete('detailId');
                searchParams.set('detailEntityType', 'program');
                searchParams.set('detailEntityId', props.programId);
            }

            setSearchParams(searchParams);
        }

        if (isOneStory) {
            analytics.track('event_ui.detail.open_clicked', {
                type: 'program',
                storyId: props.storyIds[0],
                title: props.title
            });
        } else {
            analytics.track('event_ui.detail.open_clicked', {
                type: 'program_list',
                storyIdsLength: (props.storyIds?.length ?? 0).toString(),
                title: props.title
            });
        }
    }

    if (!props.storyIds?.length) {
        return null;
    }

    return (
        <S_ShowDetailButton className={props.className}>
            <ProgramListItemActionButton
                isWide={isWide}
                onClick={handleInfoClick}
                icon={['far', 'info']}
            />
        </S_ShowDetailButton>
    );
};

const S_ShowDetailButton = styled.div``;
